import { FC, useMemo } from 'react';
import { Autocomplete, TextField } from '@mui/material';

interface SingleSelectFilterProps {
  field: string;
  label: string;
  value: string[];
  options?: string[];
  onChange: (field: string, value: string[]) => void;
}

export const TicketSelectFilter: FC<SingleSelectFilterProps> = ({
  field,
  label,
  value = [],
  options = [],
  onChange,
}) => {
  const processedOptions = useMemo(() => options, [options]);

  const handleChange = (_: any, newValue: string | null) => {
    if (newValue) {
      onChange(field, [newValue]);
    } else {
      onChange(field, []);
    }
  };

  return (
    <Autocomplete
      options={processedOptions}
      value={value[0] || null}
      onChange={handleChange}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="outlined"
          size="small"
          placeholder={`Select ${label}`}
        />
      )}
    />
  );
};
